import React from 'react';
import ReCAPTCHA, { ReCAPTCHAProps } from 'react-google-recaptcha';

interface CaptchaProps extends ReCAPTCHAProps {
  handleChildCaptchaToken?: (token: string | null) => string;
  shouldShowCaptcha?: boolean;
}

const Captcha = (props: CaptchaProps): React.ReactElement | null => {
  const captchaRef = React.useRef<ReCAPTCHA | null>(null);
  const { handleChildCaptchaToken, shouldShowCaptcha = false } = props;
  const handleChange = async (token: string | null) => {
    if (token) {
      //@ts-ignore
      if (window.ReactNativeWebView) {
        //@ts-ignore
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ token, type: 'GOOGLE_RECAPTCHA_TYPE' })
        );
      }
      handleChildCaptchaToken?.(token);
    }
  };

  React.useEffect(() => {
    //@ts-ignore
    window.recaptchaOptions = {
      enterprise: true
    };
  }, []);
  if (!shouldShowCaptcha) return null;
  return (
    <div>
      <ReCAPTCHA
        {...props}
        ref={captchaRef}
        title="Google Captcha"
        sitekey={process.env.REACT_APP_ENTERPRISE_CAPTCHA_KEY_V2!}
        onChange={handleChange}
      />
    </div>
  );
};

export default Captcha;
